import React from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { TGDComponent } from '../../../../models/courses/graphicDesign';
import { FONT_PAIRS } from '../../core/fonts';

interface TextPanelProps {
  selected?: TGDComponent; onAdd: (kind: 'title' | 'subtitle' | 'body') => void;
  onUpdate: (patch: Partial<TGDComponent>) => void;
}

const TextPanel: React.FC<TextPanelProps> = ({ selected, onAdd, onUpdate }) => {
  const { t } = useTranslation();
  return <section className="gd-panel">
    <h3>{t('graphicDesignLesson.editor.text')}</h3>
    {(['title', 'subtitle', 'body'] as const).map(kind => <Button key={kind}
      className="gd-wide" onClick={() => onAdd(kind)}>
      {t(`graphicDesignLesson.editor.textKind.${kind}`)}
    </Button>)}
    <h4>{t('graphicDesignLesson.editor.fonts')}</h4>
    {FONT_PAIRS.map(pair => <Button key={pair.id} className="gd-font-choice"
      disabled={selected?.type !== 'text'} onClick={() => onUpdate({ fontPair: pair.id })}
      style={{ fontFamily: pair.heading }}>
      {pair.label}
    </Button>)}
  </section>;
};

export default TextPanel;
